import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import useQueryApplicationCount from "./useQueryApplicationCount";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PageSubtitle from "../../common/widgets/PageSubtitle";
import ApplicationApprovalStatusCountItem from "./ApplicationApprovalStatusCountItem";
import "./ApplicationCountItem.scss";
import CandidateApprovalStatusEnum from "../../candidates/CandidateApprovalStatusEnum";

export default function ApplicationCountItem(props) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "ApplicationCountItem");

  const { data: count, loading, errors } = useQueryApplicationCount();

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <div className="ApplicationCountItem">
            <PageSubtitle
              colTitle={t("admin:admin_dashboard_application_count_title")}
            />
            <Row>
              <Col className="application-count">
                <span>{count}</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <ApplicationApprovalStatusCountItem
                  approvalStatus={CandidateApprovalStatusEnum.APPROVED}
                  statusLabel={t(
                    "admin:admin_dashboard_application_count_approved_title"
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <ApplicationApprovalStatusCountItem
                  approvalStatus={CandidateApprovalStatusEnum.PENDING}
                  statusLabel={t(
                    "admin:admin_dashboard_application_count_pending_title"
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <ApplicationApprovalStatusCountItem
                  approvalStatus={CandidateApprovalStatusEnum.REJECTED}
                  statusLabel={t(
                    "admin:admin_dashboard_application_count_rejected_title"
                  )}
                />
              </Col>
            </Row>
          </div>
        )}
      />
    </HorizontalLoader>
  );
}
